import React from "react";
import { FormattedMessage } from "react-intl";
import {STEPS} from "./steps/registry";
import {connect} from "react-redux";
import {setWizardConflictPopupOpened} from "../../../actions/wizardFunctions";
import {enableSquareFootage} from "../../../actions/sqftFunctions";
import {setSQFTPopup} from "../../../actions/sqftMenuFunctions";
import {useChangeWizardStepRoute} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {handleOpenModalFix} from "../../sqft/components/popup/modalFix/CompatibilityWarnings/modalFixHelper";

const WizardConflictPopupSQFTButtons = (props) => {
  const { hideOverlay, setWizardConflictPopupOpened, step, setStep, isSquareFootageEnabled, enableSquareFootage } = props
  const { changeWizardStepRoute } = useChangeWizardStepRoute();

  const BUTTONS_IN_SQFT = {
    [STEPS.REVIEW]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        // Close overlay and then finalize popup close
        onClick: (hideOverlay) => hideOverlay?.(() => {
          setWizardConflictPopupOpened(false);
          setStep(STEPS.REVIEW);
        }),
      },
      primary: {
        id: "confirmPopup.editItems",
        className: "ui-button2 ui-button2--green",
        onClick: async (hide) => {
          // await dispatch(applyConflictResolutions());
          hide?.(() => {
            setWizardConflictPopupOpened(false);
            setStep(STEPS.REVIEW);
            enableSquareFootage(true);
            handleOpenModalFix({changeWizardStepRoute});
            enableSquareFootage(true);
          });
        },
      },
    }
  }
  const BUTTONS_IN_VISUALIZER = {
    [STEPS.REVIEW]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        // Close overlay and then finalize popup close
        onClick: (hideOverlay) => hideOverlay?.(() => {
          setWizardConflictPopupOpened(false);
          setStep(STEPS.REVIEW);
        }),
      },
      primary: {
        id: "confirmPopup.editItems",
        className: "ui-button2 ui-button2--green",
        onClick: () => setStep(STEPS.FIX),
      },
    },
    [STEPS.FIX]: {
      secondary: {
        id: "confirmPopup.cancel",
        className: "ui-button2 ui-button2--blue",
        onClick: () => setStep(STEPS.REVIEW),
      },
      primary: {
        id: "confirmPopup.applyAndContinue",
        className: "ui-button2 ui-button2--green",
        onClick: async (hide) => {
          // await dispatch(applyConflictResolutions());
          hide?.(() => {
            setWizardConflictPopupOpened(false);
            setStep(STEPS.REVIEW);
            enableSquareFootage(true);
            handleOpenModalFix({changeWizardStepRoute});
          });
        },
      },
    },
  };

  const { secondary, primary } = isSquareFootageEnabled ? BUTTONS_IN_SQFT[step] : BUTTONS_IN_VISUALIZER[step];

  const renderBtn = (btn) => {
    if (!btn) return null;
    const handleClick = () => btn.onClick?.(hideOverlay);
    return (
      <button
        type="button"
        className={btn.className || "btn conflict-popup__btn"}
        onClick={handleClick}
      >
        <FormattedMessage id={btn.id} />
      </button>
    );
  };

  return (
    <div className="ui-popup__footer conflict-popup__footer">
      {renderBtn(secondary)}
      {renderBtn(primary)}
    </div>
  );
};

const mapStateToProps = (store) => ({
  isSquareFootageEnabled: store.sqftState.isSquareFootageEnabled,
});

const mapDispatchToProps = {
  setWizardConflictPopupOpened,
  enableSquareFootage,
  setSQFTPopup
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardConflictPopupSQFTButtons);

